export const environment = {
  production: false,
  staging: true,
  apiBaseUrl: 'https://api-staging.rentwize.au',
  appVersion: '1.0.0',
  appBuild: 'staging',
};